module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fixtures-stats">\n	<h3>\n		<strong>2025</strong> SEASON SO FAR\n	</h3>\n	<div class="fixtures-stats-header"></div>\n	<div class="fixtures-stats-table"></div>\n</div>\n\n<div class="upcoming-fixtures-stats">\n	<h3>\n		<strong>2025</strong> UPCOMING FIXTURE\n	</h3>\n	<div class="upcoming-fixtures-stats-header"></div>\n	<div class="upcoming-fixtures-stats-table"></div>\n</div>';
}
return __p;
};
